import { SxProps, Theme } from '@mui/material'
import { keyframes } from '@mui/system'

const matchesLinesAnimation = (size: 'large' | 'small') =>
  keyframes({
    '0%': {
      width: size === 'large' ? '8rem' : '5rem',
      height: size === 'large' ? '8rem' : '5rem',
    },
    '100%': {
      width: size === 'large' ? '9rem' : '6rem',
      height: size === 'large' ? '9rem' : '6rem',
    },
  })
export const matchesLinesSx = (size: 'large' | 'small'): SxProps<Theme> => {
  return {
    position: 'absolute',
    width: '100%',
    height: '100%',
    animation: `${matchesLinesAnimation(
      size
    )} 1s linear infinite alternate-reverse`,
  }
}

export const containerSx = (size: 'large' | 'small'): SxProps<Theme> => {
  return {
    position: 'relative',
    width: size === 'large' ? '9rem' : '6rem',
    height: size === 'large' ? '9rem' : '6rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}

export const matchesIconSx = ({
  color,
  size,
}: {
  color: 'light' | 'dark'
  size: 'large' | 'small'
}): SxProps<Theme> => {
  return {
    width: size === 'large' ? '6rem' : '4rem',
    height: size === 'large' ? '6rem' : '4rem',
    color: (theme) =>
      color === 'light'
        ? theme.palette.secondary.light
        : theme.palette.secondary.main,
  }
}
